document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function(_defaultTemplate, hit, html, components) {
    
     var compare_tag = "none";
      var software_tag = "none";
      var open_box_tag = "none";
      var in_stock_tag = "none";
      var new_tag = "none";
      var in_stock_status = "green";
    var hide_price = "none"
      
      var show_price = "block";
    let ratio = 0;
    let ratio_string = "0";


      if (hit.tags.includes("__label:Open_Box"))
        open_box_tag = "block";

      // Check for hide_price tag OR metafield
      var hidePriceByMeta = false;
      try {
        hidePriceByMeta = !!(hit.metafields && hit.metafields.custom && (hit.metafields.custom.hide_price === true || hit.metafields.custom.hide_price === 'true'));
      } catch(e) {}

      if (hit.tags.includes("hide_price") || hidePriceByMeta)
        show_price = "none";
        
      if (hit.tags.includes("xchange"))
        software_tag = "block";

      if (hit.tags.includes("status:in-stock"))
        in_stock_tag = "block";

      if (hit.tags.includes("New_Item"))
        new_tag = "block";
      
      
      else {
      // Original price display logic
      if (hit.compare_at_price > 0) {
        ratio = (hit.price * 100) / hit.compare_at_price;
        ratio_string = ratio > 90 
          ? `$${(hit.compare_at_price - hit.price).toFixed(2)}`
          : `${100 - Math.round(ratio)}%`;
        compare_tag = "block";
        show_price = "none";
      }
    }
    
    return html`
      <div
        class="ais-hit ais-product"
        data-algolia-index="${hit.index}"
        data-algolia-position="${hit.productPosition}"
        data-algolia-queryid="${hit.queryID}"
        data-algolia-objectid="${hit.objectID}"
        data-handle="${hit.handle}"
        data-variant-id="${hit.objectID}"
        data-distinct="${hit._distinct}"
        data-product-id="${hit.id}"
        style="background-color:white; padding-bottom: 10px;"
        onClick="${() => algoliaShopify.helpers.handleItemClick(hit)}"
      >
      <div style="position:relative;width:100%;">
        <div class="product-item__label-list">
          <span class="product-label product-label--custom1" style="display:${open_box_tag};font-weight:normal;padding:2px 5px; font-size: 12px;">Open Box</span>
          <span class="product-label product-label--custom1" style="display:${software_tag};font-weight:normal;padding:2px 5px; font-size: 12px;">Downloadable Software</span>
          <span class="product-label product-label--on-sale" style="display:${compare_tag};font-weight:normal;padding:2px 5px; font-size: 12px;">Save ${ratio_string}</span>
          <span class="product-label available-label" style="display:${in_stock_tag};font-weight:normal; background-color:black;padding:2px 5px; font-size: 12px;">In-Stock <span class="availabel-status" style="color:${in_stock_status}; font-size: small;">●</span></span>
          <span class="product-label available-label" style="display:${new_tag};font-weight:normal; background-color:black;padding:2px 5px; font-size: 12px;">New <span class="availabel-status" style="color:${in_stock_status};"></span></span>
        </div>
        </div>
        
        <img
          class="ais-hit--picture"
          src="${algoliaShopify.helpers.mediumImage(hit)}"
          alt="${hit.title} - ${hit.variant_title}"
        />

        <div class="ais-hit--details" style="padding:20px;">
          <p class="ais-hit--title">
            <a
              data-algolia-index="${hit.index}"
              data-algolia-position="${hit.productPosition}"
              data-algolia-queryid="${hit.queryID}"
              data-algolia-objectid="${hit.objectID}"
              href="${algoliaShopify.helpers.instantsearchLink(hit)}"
              title="${algoliaShopify.helpers.fullTitle(
                hit.title,
                hit._distinct,
                hit.variant_title
              )}"
            >
              ${components.Highlight({ attribute: 'title', hit })}
              ${algoliaShopify.helpers.variantTitleAddition(hit, hit._distinct)}
            </a>
          </p>
          <p
            class="ais-hit--subtitle"
            title="${hit.product_type}${algoliaShopify.translation_helpers.by(
              hit.vendor
            )}"
          >
            ${components.Highlight({ attribute: 'product_type', hit })}
            ${hit.vendor &&
              html`
                <span> ${algoliaShopify.translations.by} </span>
              `}
            ${hit.vendor && components.Highlight({ attribute: 'vendor', hit })}
          </p>
          <div class="ais-hit--price" style="padding-top:5px; height:40px">
            <div class="price price--highlight" data-money-convertible="" style="display:${show_price};font-size: 20px;">${algoliaShopify.helpers.displayPrice(hit, hit._distinct)}</div>
            <div class="product-item__price-list price-list" style="display:${compare_tag};">
            <div style="display: flex;justify-content: flex-start;align-items:center;gap: 30px;color:#666666;"><span class="price price--highlight" data-money-convertible="" style="font-size: 20px;">${algoliaShopify.helpers.displayPrice(hit, hit._distinct)}</span>$${hit.compare_at_price} CAD</div></div>
          </div>
          <!-- Extra info examples - Remove the display: none to show them -->
          <p class="ais-hit--info" style="display: none">
            ${hit.sku &&
              html`
                <span class="algolia-sku"
                  >${components.Highlight({ attribute: 'sku', hit })}</span
                >
              `}
            ${hit.barcode &&
              html`
                <span class="algolia-barcode"
                  >${components.Highlight({ attribute: 'barcode', hit })}</span
                >
              `}
            ${hit.weight &&
              html`
                <span class="algolia-weight">${hit.weight}</span>
              `}
            ${!hit.taxable &&
              html`
                <span class="algolia-taxable"
                  >${algoliaShopify.translations.taxFree}</span
                >
              `}
          </p>
          <!-- Tags example - Remove the display: none to show them -->
          <p class="ais-hit--tags" style="display: none">
            ${hit?._highlightResult.tags?.map(
              tag =>
                html`
                  <span class="ais-hit--tag">${tag.value}</span>
                `
            )}
          </p>
          ${!hit._distinct &&
            html`
              <form
                id="algolia-add-to-cart-${hit.objectID}"
                style="display: none;"
                action="/cart/add"
                method="post"
                enctype="multipart/form-data"
              >
                <input type="hidden" name="id" value="${hit.objectID}" />
              </form>
              <p class="ais-hit--cart">
                ${hit.can_order
                  ? html`
                      <button
                        class="ais-hit--cart-button"
                        data-form-id="algolia-add-to-cart-${hit.objectID}"
                      >
                        ${algoliaShopify.translations.addToCart}
                      </button>
                    `
                  : html`
                      <button
                        class="ais-hit--cart-button ais-hit--cart-button__disabled"
                      >
                        ${algoliaShopify.translations.outOfStock}
                      </button>
                    `}
              </p>
            `}
        </div>
      </div>
    `;
  });
});

document.addEventListener("algolia.hooks.initialize", function () {
  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteProductTemplate",
    function (_defaultTemplate, templateOptions, distinct, itemLink) {
      // Modify default options, then return them
      const { html, item, components } = templateOptions;
      
      var compare_tag = "none";
      var software_tag = "none";
      var open_box_tag = "none";
      var in_stock_tag = "none";
      var new_tag = "none";
      var in_stock_status = "green";
      
      var show_price = "block";
      let ratio = 0;
      let ratio_string = "0";

      if (item.tags.includes("__label:Open_Box"))
        open_box_tag = "block";

      if (item.tags.includes("xchange"))
        software_tag = "block";

      // if (hit.tags.includes("hide_price"))
      //   show_price = "none";

      if (item.tags.includes("status:in-stock"))
        in_stock_tag = "block";

      if (item.tags.includes("New_Item"))
        new_tag = "block";
      
      if (item.compare_at_price > 0) {
        ratio = item.price * 100 / item.compare_at_price;
        if (ratio > 90){
          ratio_string = "$" + (item.compare_at_price - item.price).toFixed(2);
        } else {
          ratio_string = (100 - Math.round(ratio)) + "%";
        }
        compare_tag = "block";
        show_price = "none";
      }
      
      return html`
    <a href="${itemLink}" class="aa-ItemLink aa-ProductItem" onClick="${() => algoliaShopify.helpers.handleItemClick(item)}">
      <div class="aa-ItemContent">
      <div style="position:relative;width:100%;">
        <div class="product-item__label-list">
          <span class="product-label product-label--custom1" style="display:${open_box_tag};font-weight:normal">Open Box</span>
          <span class="product-label product-label--custom1" style="display:${software_tag};font-weight:normal">Downloadable Software</span>
          <span class="product-label product-label--on-sale" style="display:${compare_tag};font-weight:normal">Save ${ratio_string}</span>
          <span class="product-label available-label" style="display:${in_stock_tag};font-weight:normal; background-color:black">In-Stock <span class="availabel-status" style="color:${in_stock_status};">●</span></span>
          <span class="product-label available-label" style="display:${new_tag};font-weight:normal; background-color:black">New <span class="availabel-status" style="color:${in_stock_status};"></span></span>
        </div>
        </div>
        <div class="aa-ItemPicture aa-ItemPicture--loaded">
          <img src="${algoliaShopify.helpers.compactImage(item)}" alt="${item.title}" />
        </div>
        <div class="aa-ItemContentBody">
        <div class="aa-ItemContentPrice ">
            <div class="aa-ItemContentPriceCurrent" style="font-weight:normal;">
              <span class="price " data-money-convertible="" style="display:${show_price};font-size: 20px;">
                ${(item.tags.includes("hide_price") || (item.metafields && item.metafields.custom && (item.metafields.custom.hide_price === true || item.metafields.custom.hide_price === 'true'))) ? 
                "" : 
                algoliaShopify.helpers.displayPrice(item, distinct)
                }
              </span>
              <div class="product-item__price-list price-list" style="display:${compare_tag};">
              <span class="price price--highlight" data-money-convertible="" style="font-size: 20px;">${algoliaShopify.helpers.displayPrice(item, distinct)}</span>$${item.compare_at_price} CAD</div>
            </div>
          </div>
          <div class="aa-ItemContentTitleWrapper">
            <div class="product-item__title link">
              ${components.Highlight({ hit: item, attribute: "title" })}
              <span>
                ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
              </span>
            </div>
          </div>    
        </div>
      </div>
    </a>
  `;
    }
  );
});
